import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { ShiftDocument } from '../Shifts/queryBuilder';
import { SiteDocument } from '../Site/queryBuilder';
import { BorerShiftDocument, borerShiftPullQueryBuilder } from './queryBuilder';

export function borerShiftFamilyMember(
  configBuilder: ConfigBuilder,
  equipment: FamilyMember<EquipmentDocument>,
  shift: FamilyMember<ShiftDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerShiftDocument> {
  const syncConfig = configBuilder<BorerShiftDocument>(RxdbCollectionNameV2.BORER_SHIFT);
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT, replicationState, [sites]);
}
